<div class="flex items-center gap-[0.375rem] rounded-[0.625rem] py-[0.1875rem] pl-[0.25rem] pr-[0.75rem]"
     [class]="statusTheme()">
  <gc-icon-badge [iconSrc]="statusIcon()"
                 [alt]="statusLabel() | translate"
                 [background]="statusIconBackground()"
                 size="1.625rem"></gc-icon-badge>

  <span class="text-[0.6875rem] font-semibold leading-[150%] whitespace-nowrap" [translate]="statusLabel()"></span>
</div>

@let icon = resultIcon();

@if (icon) {
  <div class="flex items-center gap-[0.5rem] rounded-[0.5rem] py-[0.25rem] pl-[0.25rem] pr-[0.75rem]"
       [class]="resultTheme()">
    <gc-icon-badge [iconSrc]="icon"
                   [alt]="(resultLabel() ?? '') | translate"
                   [background]="resultIconBackground()"
                   [overlayIconSrc]="resultOverlayIcon()"
                   size="1.625rem"></gc-icon-badge>

    <span class="text-[0.6875rem] font-medium leading-[150%] whitespace-nowrap" [translate]="resultLabel() ?? ''"></span>
  </div>
}
